export default "__VITE_ASSET__DmkSkt9a__"